import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Server, Flame, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export const SERVICENOW_ACCENT = "#22c55e";

export default function ServiceNowTrackCard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/servicenow/track/me").then((res) => setStats(res.data)).catch(() => {});
  }, []);

  const pct = stats ? Math.round((stats.days_completed / stats.total_days) * 100) : 0;

  return (
    <Link
      to="/servicenow"
      data-testid="dashboard-servicenow-track-card"
      className="group relative rounded-[18px] border border-[#232d42] bg-[#131a29] p-5 pt-6 block transition-all duration-300 hover:-translate-y-1 hover:border-[#22c55e]/60 hover:shadow-[0_12px_40px_rgba(34,197,94,0.15)] overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-[3px] bg-[#22c55e]" />
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Server className="w-4 h-4 text-[#22c55e]" />
          <span className="text-xs font-bold uppercase tracking-wider text-[#22c55e]">ServiceNow Track</span>
        </div>
        {stats && stats.streak_current > 0 && (
          <span className="flex items-center gap-1 text-[11px] font-bold font-mono text-[#22c55e]" data-testid="dashboard-servicenow-streak">
            <Flame className="w-3 h-3" /> {stats.streak_current}
          </span>
        )}
      </div>
      <p className="text-sm font-semibold text-[#eef1f8]">30-Day ServiceNow Challenge</p>
      <p className="text-xs text-[#8993ab] mt-1">CMDB & ITSM, then Development, Flow Designer & AI Agents</p>
      <div className="w-full h-1.5 bg-[#1b2434] rounded-full overflow-hidden mt-4">
        <div className="h-full bg-[#22c55e] rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-[11px] font-mono text-[#8993ab]">{stats ? `${stats.days_completed}/${stats.total_days} days` : "Loading..."}</span>
        <span className="text-[11px] font-semibold text-[#22c55e] flex items-center gap-1 group-hover:gap-1.5 transition-all">
          {stats?.days_completed > 0 ? "Continue" : "Start"} <ArrowRight className="w-3 h-3" />
        </span>
      </div>
    </Link>
  );
}
